import { render } from "./MainView.vue?vue&type=template&id=5ee51996"
const script = {}

import "./MainView.vue?vue&type=style&index=0&id=5ee51996&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__